export const genders = ["Homme", "Femme", "Vétéran homme", "Vétéran femme", "U20/Junior", "U18/Cadet", "U16/Minime", "U14/Benjamin", "U12/Poussin", "U10/Microbe","U8 homme", "U8 femme"]
export const mainGenders = ["Homme", "Femme"]
